module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"attach_tag":"Attach tags","already_added":"Already added","undefined":"Undefined","cant_add_tag":"Can\u0027t add tag.","added_to_undefined":"added to undefined.","add":"Add"}}')
  delete Component.options._Ctor
}
